import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CountryNavbar from "../Country/CountryNavbar";
import CountryNavbarMobile from "../Country/CountryNavbarMobile";
import HomeBottomLast from "../Home/HomeBottomLast";
import HomeBottom from "../Home/HomeBottom";
import HomeFour from "../Home/HomeFour";
import HomeFive from "../Home/HomeFive";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import changeDetails from "../../store/Actions/DetailsAction";
import changeLogin from "../../store/Actions/LoginAction";
import PaymentSection from "./PaymentSection";

function Payment(props) {
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (Object.keys(props.details).length === 1) {
      history.push("/");
    }

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      props.ChangeLogin(true);
      return item.value;
    }
    getWithExpiry("userData");

    document.title = "VisaPro | Payment";
  }, []);

  return (
    <div>
      <CountryNavbar countryName={id} login={props.login} />
      <PaymentSection login={props.login}  />
      <HomeFive />
      <HomeBottom />
    </div>
  );
}

const mapStateToProps = (state) => ({
  details: state.Details.details,
  login: state.Login.login,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(Payment);
